<template>
    <div class="withdrawal-dialog-container">
        <div class="inner">
            <div class="apply" v-if="!isDetail">
                <p class="tip">
                    请开具内容为 <span>【{{ invoiceData.serviceName }}】</span>，抬头为
                    <span>【{{ invoiceData.title }}】</span>，金额为
                    <span class="price">{{ formData.price }}元</span>
                    <a class="edit-price el-icon-edit" href="javascript:" @click="editPriceDialogOpen"></a
                    ><br/>的增值税专用发票，并<span>【上传】</span>
                </p>
                <div class="info-tt">
                    发票上传
                </div>
                <div class="invoice">
                    <div class="invoice-preview">
                        <el-upload
                            accept=".pdf"
                            :action="uploadUrl"
                            :data="uploadParams"
                            :multiple="false"
                            :show-file-list="false"
                            :on-success="handleInvoiceSuccess"
                            :before-upload="beforeInvoiceUpload">
                            <!--accept=".pdf,.ofd"-->
                            <el-button size="small" plain>
                                {{ formData.invoiceurl ? '重新上传' : '点击上传' }}
                            </el-button>
                            <p slot="tip" class="tip">请上传PDF格式</p>
                            <!-- <p slot="tip" class="tip">请上传PDF/OFD格式</p>-->
                        </el-upload>

                        <div class="invoice-list"
                             v-if="formData.invoiceurl"
                        >
                            <div class="invoice-item"
                                 :class="[getFileNameExtension(formData.invoicename)]">
                                <div class="item-name" :title="formData.invoicename">
                                    {{ formData.invoicename }}
                                </div>
                                <span class="preview" @click="previewInvoiceDialog.show=true">
                                <i class="el-icon-view"></i> 预览
                            </span>
                                <span class="delete" @click="deleteInvoice()">
                                <i class="el-icon-delete"></i> 删除
                            </span>
                            </div>
                        </div>

                        <label class="error-label"
                               :class="{
                        show:!invoiceValid
                    }">
                            请上传
                        </label>
                    </div>
                    <div class="invoice-info">
                        <h5>
                            发票抬头：
                        </h5>
                        <div class="invoice-cells">
                            <div class="invoice-cell">
                                <label>
                                    抬头：
                                </label>
                                {{ invoiceData.title }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    税号：
                                </label>
                                {{ invoiceData.code }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    开户行：
                                </label>
                                {{ invoiceData.bankName }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    账号：
                                </label>
                                {{ invoiceData.bankAccount }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    电话：
                                </label>
                                {{ invoiceData.tel }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    地址：
                                </label>
                                {{ invoiceData.address }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-tt">
                    商铺信息
                </div>
                <el-form size="small" :model="formData" :rules="formRules" ref="submitForm">
                    <el-form-item>
                        <el-form-item label="户名" prop="shopName" class="required">
                            <el-input v-model="formData.shopName" placeholder="请输入" maxlength="200"></el-input>
                        </el-form-item>
                        <el-form-item label="银行账户号" prop="shopAccount" class="required">
                            <el-input v-model="formData.shopAccount" placeholder="请输入" maxlength="100"></el-input>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="开户行" prop="bankName" class="required">
                            <el-input v-model="formData.bankName" placeholder="请输入" maxlength="100"></el-input>
                        </el-form-item>
                        <el-form-item label="开户行行号（联行号）" prop="bankAccount" class="required">
                            <el-input v-model="formData.bankAccount" placeholder="请输入" maxlength="100"></el-input>
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
            <div class="detail" v-if="isDetail">
                <div class="state" :class="['state' + detailData.auditstatus]">
                    <div class="state-name">
                        {{ detailData.auditstatus | stateName }}
                        <span v-if="detailData.auditpassdate"> 审核时间：{{ detailData.auditpassdate }} </span>
                    </div>
                    <div class="state-reason" v-if="detailData.auditstatus == 4">
                        未通过原因： {{ detailData.auditsreason }}
                    </div>
                    <div class="state-tip" v-if="detailData.auditstatus == 3">审核无误后，我司会在7个工作日内打款</div>
                </div>
                <p class="tip">
                    请开具内容为 <span>【{{ invoiceData.serviceName }}】</span>，抬头为
                    <span>【{{ invoiceData.title }}】</span>，金额为
                    <span class="price">{{ detailData.applyprice }}元</span>的增值税专用发票。
                </p>
                <div class="info-tt">
                    发票上传
                </div>
                <div class="invoice">
                    <div class="invoice-preview">
                        <div class="invoice-list"
                             v-if="detailData.invoiceurl"
                        >
                            <div class="invoice-item"
                                 :class="[getFileNameExtension(detailData.invoicename)]">
                                <div class="item-name" :title="detailData.invoicename">
                                    {{ detailData.invoicename }}
                                </div>
                                <span class="preview" @click="previewInvoiceDialog.show=true">
                                <i class="el-icon-view"></i> 预览
                            </span>
                            </div>
                        </div>
                    </div>
                    <div class="invoice-info">
                        <h5>
                            发票抬头：
                        </h5>
                        <div class="invoice-cells">
                            <div class="invoice-cell">
                                <label>
                                    抬头：
                                </label>
                                {{ invoiceData.title }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    税号：
                                </label>
                                {{ invoiceData.code }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    开户行：
                                </label>
                                {{ invoiceData.bankName }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    账号：
                                </label>
                                {{ invoiceData.bankAccount }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    电话：
                                </label>
                                {{ invoiceData.tel }}
                            </div>
                            <div class="invoice-cell">
                                <label>
                                    地址：
                                </label>
                                {{ invoiceData.address }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="info-tt">
                    店铺信息
                </div>
                <el-form size="small">
                    <el-form-item>
                        <el-form-item label="户名" class="required">
                            {{ detailData.accountname }}
                        </el-form-item>
                        <el-form-item label="银行账户号" class="required">
                            {{ detailData.bank_account_name }}
                        </el-form-item>
                    </el-form-item>
                    <el-form-item>
                        <el-form-item label="开户行" class="required">
                            {{ detailData.bank_account_num }}
                        </el-form-item>
                        <el-form-item label="开户行行号（联行号）" class="required">
                            {{ detailData.bank_account_code }}
                        </el-form-item>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="footer" v-if="!isDetail">
            <p>审核无误后，我司会在7个工作日内打款</p>
            <div class="footer-btns">
                <el-button type="primary" size="small" @click="submit">
                    提交审核
                </el-button>
                <el-button size="small" @click="closeWithdrawalDialog">
                    取消
                </el-button>
            </div>
        </div>

        <el-dialog
            custom-class="edit-price-dialog"
            title="提现金额确认"
            :visible.sync="editPriceDialog.show"
            width="420px"
            append-to-body
            destroy-on-close
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            @close="editPriceDialogClose"
        >
            <div class="edit-price-dialog-body">
                <el-input-number
                    class="message-input"
                    v-model="editPriceDialog.price"
                    controls-position="right"
                    :min="0"
                    size="small"
                    placeholder="请输入需要提现的金额"
                >
                </el-input-number>
                <p class="message-tip">
                    每月1号至7号可提现一次，{{ this.minWithdrawPrice }}元起兑，当前余额为
                    {{ this.userInfo.accountBalance }}元
                </p>
                <div class="btns">
                    <el-button size="small" plain type="primary" @click="editPriceDialogClose">取消</el-button>
                    <el-button size="small" type="primary" @click="editPriceConfirm">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="previewInvoiceDialog.show"
            title="发票"
            custom-class="preview-invoice-dialog"
            width="800px"
            append-to-body
            destroy-on-close
            :close-on-press-escape="false"
            :close-on-click-modal="false"
        >
            <iframe
                style="width: 100%;height:100%;border: none;"
                :src="formData.invoiceurl" frameborder="0"></iframe>
        </el-dialog>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import {createGuid, getFileNameExtension, getRedirectUrl} from '@/util/util';

export default {
    name: 'WithdrawalDialog',
    props: {
        guid: {
            type: String,
            default: ''
        },
        isDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            rowguid: '',
            uploadUrl: '',
            submitForm: null,
            formData: {
                price: 0,
                shopName: '',
                shopAccount: '',
                bankName: '',
                bankAccount: '',
                invoiceguid: '',
                invoiceurl: ''
            },
            formRules: {
                shopName: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                shopAccount: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                bankName: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                bankAccount: [
                    {
                        required: true,
                        message: '请输入',
                        trigger: 'blur'
                    }
                ],
                image: [
                    {
                        required: true,
                        message: '请上传',
                        trigger: 'change'
                    }
                ]
            },
            invoiceValid: true,
            invoiceData: {
                serviceName: '信息技术服务费*技术服务费',
                title: '安徽国泰新点软件有限公司',
                code: '91340100MA2W5D5208',
                bankName: '中国建设银行股份有限公司合肥科技支行',
                bankAccount: '34050110292900002042',
                tel: '0551-64664620',
                address: '安徽省合肥市高新区黄山路622号高芯光谷601室'
            },
            detailData: {},
            minWithdrawPrice: 10,
            uploadParams: {
                cliengguid: '',
                clienttag: 'invoice'
            },
            editPriceDialog: {
                show: false,
                price: 0
            },
            uploadLoading: null,
            previewInvoiceDialog: {
                show: false
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo'])
    },
    mounted() {
        this.uploadUrl = window.service.uploadattachInfo.url;
        this.submitForm = this.$refs.submitForm;
        this.rowguid = createGuid();
        if (this.guid) {
            this.rowguid = this.guid;
            this.getWithdrawalRecordDetail();
        }
    },
    methods: {
        getFileNameExtension(name) {
            return getFileNameExtension(name)
        },
        getWithdrawalRecordDetail() {
            this.$Api
                .getWithdrawalRecordDetail({
                    applyguid: this.guid
                })
                .then((data) => {
                    this.detailData = data;
                    this.formData.invoiceurl = data.invoiceurl;
                });
        },
        editPriceDialogOpen() {
            this.editPriceDialog.price = this.formData.price;
            this.editPriceDialog.show = true;
        },
        editPriceDialogClose() {
            this.editPriceDialog.price = 0;
            this.editPriceDialog.show = false;
        },
        editPriceConfirm() {
            if (this.editPriceDialog.price < this.minWithdrawPrice) {
                this.$message({
                    type: 'error',
                    message: '提现金额' + this.minWithdrawPrice + '元起兑！'
                });
                return;
            } else if (this.editPriceDialog.price > this.userInfo.accountBalance) {
                this.$message({
                    type: 'error',
                    message: '您所输入的提现金额超出账户余额！'
                });
                return;
            } else {
                this.formData.price = this.editPriceDialog.price;
                this.editPriceDialogClose();
            }
        },
        submit() {
            if (!this.formData.invoiceurl) {
                this.invoiceValid = false;
            } else {
                this.invoiceValid = true;
            }
            if (this.formData.price < this.minWithdrawPrice) {
                this.$message({
                    type: 'error',
                    message: '提现金额' + this.minWithdrawPrice + '元起兑！'
                });
            } else if (this.formData.price > this.userInfo.accountBalance) {
                this.$message({
                    type: 'error',
                    message: '您所输入的提现金额超出账户余额！'
                });
            }
            this.submitForm.validate().then(() => {
                if (
                    this.formData.invoiceurl &&
                    this.formData.price >= this.minWithdrawPrice &&
                    this.formData.price <= this.userInfo.accountBalance
                ) {
                    let params = {
                        rowguid: this.rowguid,
                        userguid: this.userInfo.userguid,
                        applyprice: this.formData.price,
                        invoiceguid: this.formData.invoiceguid,
                        invoicename: this.formData.invoicename,
                        accountname: this.formData.shopName,
                        bank_account_name: this.formData.shopAccount,
                        bank_account_num: this.formData.bankName,
                        bank_account_code: this.formData.bankAccount
                    };
                    this.$Api
                        .submitWithdrawalApply(params, {
                            showLoading: true
                        })
                        .then((data) => {
                            this.$message({
                                type: data.state,
                                message: data.message
                            });
                            if (data.state === 'success') {
                                this.closeWithdrawalDialog();
                            }
                        });
                }
            });
        },
        closeWithdrawalDialog() {
            this.$emit('closeWithdrawalDialog');
        },
        beforeInvoiceUpload(file) {
            this.uploadParams.cliengguid = this.rowguid;
            let extension = getFileNameExtension(file.name);

            const isPDF = extension === 'pdf' || extension === 'PDF';
            const isOFD = extension === 'ofd' || extension === 'OFD';
            const isValidType = isPDF || isOFD;

            // 检查文件大小（限制为10MB）
            const isLt10M = file.size / 1024 / 1024 < 10;

            if (!isValidType) {
                this.$message.error('只能上传 PDF/OFD 格式的文件！');
                return false;
            }
            if (!isLt10M) {
                this.$message.error('文件大小不能超过 10MB！');
                return false;
            }

            this.uploadLoading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            return true;
        },
        handleInvoiceSuccess(res, file) {
            this.uploadLoading && this.uploadLoading.close();

            this.uploadParams.cliengguid = '';

            if (res.code != 200 && res.code != 1) {
                this.$message.error(res.msg);
                return;
            }
            let data = res.data;

            this.formData.invoiceguid = data.attachguid;
            this.formData.invoicename = file.name;
            this.formData.invoiceurl = getRedirectUrl(window.Config.previewContractDialogUrl, {
                attachguid: data.attachguid,
                ispreview: 1
            });
            this.invoiceValid = true;

            // 如果验证通过，返回true允许上传
            return true;
        },
        deleteInvoice() {
            this.formData.invoiceguid = '';
            this.formData.invoicename = '';
            this.formData.invoiceurl = '';
            this.invoiceValid = false;
        }
    },
    filters: {
        stateName(e) {
            let name = '';
            switch (e.toString()) {
                case '1':
                    name = '待提交';
                    break;
                case '2':
                    name = '审核中';
                    break;
                case '3':
                    name = '审核通过';
                    break;
                case '4':
                    name = '审核不通过';
                    break;
                default:
            }
            return name;
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/withdrawal-dialog.scss';
</style>
